import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import addTourRegister from "./component/addTourRegister.vue";
import courseList from "./component/courseList.vue";
export default {
  name: "eventmanage",
  components: {
    addTourRegister: addTourRegister,
    courseList: courseList
  },
  mixins: [loadMoreList, commonData],
  props: ['teamId'],
  data: function data() {
    return {
      paramsData: {// name: '',
      },
      tableData: [],
      total: 0,
      formatMap: {
        "league": '联赛制',
        "knockout": '淘汰制',
        "group+knockout": '小组赛+淘汰赛'
      },
      tournamentMap: {
        "official": '正式赛事',
        "friendly": '友谊赛',
        "youth": '青少年赛事'
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this.paramsData.page = page;

                _this.$api.getTourList(_objectSpread(_objectSpread({}, _this.paramsData), {}, {
                  team_id: _this.teamId
                })).then(function (res) {
                  if (res.code == 200) {
                    _this.tableData = res.data.data;
                    _this.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleMange: function handleMange() {
      this.$router.push('/coachmanage/teammanage');
    }
  }
};